import * as Request from '../Request';

const Role = {
  // 新增角色
  addRole: (data) => {
    return Request.post('/sys/role/save', data);
  },
  // 删除角色
  delRole: (data) => {
    return Request.delBody('/sys/role/delete', data);
  },
  // 编辑角色
  editRole: (data) => {
    return Request.put('/sys/role/update', data);
  },
  // 获取角色列表
  getRoleList: (data) => {
    return Request.post('/sys/role/list', data);
  },
  // 获取角色详情
  getRoleDetail: (data) => {
    return Request.get('/sys/role/info', data);
  },
  // 获取角色权限
  getRoleAuth: (data) => {
    return Request.get('/sys/role/menu/list', data);
  },
  // 获取角色权限
  setRoleAuth: (data) => {
    return Request.put('/sys/menu/privilege', data);
  }
}
export default Role
